import { getBaoCaoMuaHangNhomTheoHaiChiTieuColumns } from '../utils/excel-export/column-mapping';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';
import { QUERY_KEYS } from '@/constants';
import { useReport } from '@/hooks';

export const useReportExport = (queryParams?: MuaHangRecord) => {
  const { entity } = useAuth();
  const { getAll } = useReport({
    endpoint: QUERY_KEYS.BAO_CAO_MUA_HANG_NHOM_THEO_2_CHI_TIEU
  });

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Không tìm thấy thông tin đơn vị.',
        variant: 'default'
      });
      return;
    }

    try {
      const { exportFromApi } = await import('../utils/excel-export');
      const columns = getBaoCaoMuaHangNhomTheoHaiChiTieuColumns(queryParams?.detail_by);

      await exportFromApi({
        queryParams,
        getAll,
        excelOptions: { columns }
      });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug && queryParams)
  };
};
